import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotFoundPageContainer } from './style';

const NotFoundPage = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const hash = window.location.hash || ''
    navigate(`${'/'}${hash}`)
  },[])

  return (
    <NotFoundPageContainer data-testid="notfoundpage">
      Page Not Found
    </NotFoundPageContainer>
  )
};

export default NotFoundPage;
